import { FC, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Icon } from "@chakra-ui/react";

import { SbpIcon } from "../../../../icons";
import { RoutesMap } from "../../../../../routes.tsx";
import { useGetSbpTransferBanksQuery } from "../../../../../api/sbpTransfer";
import { useSbpTransferStore } from "../../../../../store/sbpTransferStore.ts";

export const SbpTransferBanksPageButton: FC = () => {
  const navigate = useNavigate();
  const { data } = useGetSbpTransferBanksQuery();

  const { selectedBankSchema, setSelectedBankName } = useSbpTransferStore(state => state);

  const onClick = useCallback(() => {
    if (!selectedBankSchema) return;

    const bankName = data?.find(bank => bank.schema === selectedBankSchema)?.bankName || "";
    setSelectedBankName(bankName);

    navigate(RoutesMap.sbpTransfer.processing);
  }, [selectedBankSchema, data, setSelectedBankName, navigate]);

  return (
    <Button
      mt="24px"
      colorScheme="brand"
      onClick={onClick}
      isDisabled={!selectedBankSchema}
    >
      Перевести

      <Icon as={SbpIcon} w="14px" h="17px" ml="7px" isDisabled={!selectedBankSchema} />
    </Button>
  );
};
